import axios from 'axios';

export const vivasamApi = {
    postContactSave: (param: string) => {
        return axios.post<API.ContactSave.Res>(
            import.meta.env.VITE_VIVASAM_CONTACT_API + `/smartbank/api/error/item/save`,
            param
        );
    },

    postContactSavePod: (param: string) => {
        return axios.post<API.ContactSavePod.Res>(
            import.meta.env.VITE_VIVASAM_CONTACT_API + `/smartbank/api/error/print/save`,
            param,
            {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                },
            }
        );
    },

    getCodeToClass: (param: API.GetCodeToClass.Req) => {
        const queryString = new URLSearchParams(param as any).toString();
        return axios.get<API.GetCodeToClass.Res>(
            import.meta.env.VITE_VIVASAM_API + `/api/vivaclass/launcher/textbookInfo?${queryString}`
        );
    },

    getMyClasses: (param: API.MyclassClasses.Req, accessToken?: string) => {
        return axios.post<API.MyclassClasses.Res>(
            import.meta.env.VITE_VIVACLASS_API + '/api/myclass/classes',
            param,
            // {
            //     crtYear: '2024',
            //     teacherId: 'est',
            // },
            {
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        );
    },
    getMyClassMemberList: (param: API.MyClassMemberList.Req, accessToken?: string) => {
        return axios.post<API.MyClassMemberList.Res>(
            import.meta.env.VITE_VIVACLASS_API + '/api/myclass/classMemberList',
            param,
            {
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        );
    },
    postEvaluateSave: (param: API.EvaluateSave.Req, accessToken?: string) => {
        return axios.post<API.EvaluateSave.Res>(
            import.meta.env.VITE_VIVACLASS_API + '/api/sbank/evaluate/save',
            param,
            {
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        );
    },
    postEvaluateUpdate: (param: API.EvaluateUpdate.Req, accessToken?: string) => {
        return axios.post<API.EvaluateUpdate.Res>(
            import.meta.env.VITE_VIVACLASS_API + '/api/sbank/evaluate/update',
            param,
            {
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        );
    },
    getClassInfo: (param: API.GetClassInfo.Req, accessToken?: string) => {
        return axios.post<API.GetClassInfo.Res>(
            import.meta.env.VITE_VIVACLASS_API + '/api/aidt/getClassInfo',
            param,
            {
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        );
    },
    getAuthLogin: async (param: API.AuthLogin.Req) => {
        try {
            const response = await axios.post<API.AuthLogin.Res>(
                import.meta.env.VITE_VIVACLASS_API + '/api/auth/login',
                param,
                {
                    headers: {
                        'Content-Type': 'application/json; charset=UTF-8',
                    },
                }
            );
            return response.data; // .data를 명시적으로 반환
        } catch (error: any) {
            // 에러 처리 추가
            if (axios.isAxiosError(error)) {
                console.error('Axios 에러:', error.message);
                if (error.response) {
                    console.error('응답 데이터:', error.response.data);
                    console.error('응답 상태:', error.response.status);
                    console.error('응답 헤더:', error.response.headers);
                }
            } else {
                console.error('API 요청 중 에러 발생:', error);
            }
            throw error; // 에러를 다시 던져서 호출하는 쪽에서 처리하도록 함
        }
    },

    // ai총평 누가기록 등록
    postRecordMultipleInsert: (
        param: API.REPORT.TCH.RecordMultipleInsert.Req,
        sVivaToken?: string
    ) => {
        return axios.post<API.REPORT.TCH.RecordMultipleInsert.Res>(
            import.meta.env.VITE_VIVACLASS_API + '/api/record/multipleInsert',
            param,
            {
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    Authorization: `Bearer ${sVivaToken}`,
                },
            }
        );
    },

    // ai총평 누가기록 수정
    postRecordInsert: (param: API.REPORT.TCH.RecordMultipleInsert.Req, sVivaToken?: string) => {
        return axios.post<API.REPORT.TCH.RecordMultipleInsert.Res>(
            import.meta.env.VITE_VIVACLASS_API + '/api/record/update',
            param,
            {
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    Authorization: `Bearer ${sVivaToken}`,
                },
            }
        );
    },

    // ai총평 누가기록 수정
    postRecordUpdate: (param: API.REPORT.TCH.RecordUpdate.Req, sVivaToken?: string) => {
        return axios.post<API.REPORT.TCH.RecordUpdate.Res>(
            import.meta.env.VITE_VIVACLASS_API + '/api/record/update',
            param,
            {
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    Authorization: `Bearer ${sVivaToken}`,
                },
            }
        );
    },

    // ai총평 누가기록 리스트
    postRecordList: (param: API.REPORT.TCH.RecordList.Req, sVivaToken?: string) => {
        return axios.post<API.REPORT.TCH.RecordList.Res>(
            import.meta.env.VITE_VIVACLASS_API + '/api/record/recordList',
            param,
            {
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    Authorization: `Bearer ${sVivaToken}`,
                },
            }
        );
    },
};
